<template>
  <div>
    <v-text-field
      v-model="datesFormat"
      label="Selecione o período"
      outlined
      :readonly="true"
      @click="menu = true"
      dense
    ></v-text-field>

    <v-dialog persistent v-model="menu" max-width="570px">
      <v-card>
        <v-card-title>
          Selecione o período
        </v-card-title>
        <v-divider class="mb-4"></v-divider>

        <v-card-text>
          <v-form ref="form">
            <v-row class="justify-center" wrap>
              <!-- Data Inicial -->
              <v-col xs="12" sm="6">
                <v-text-field
                  color="primary"
                  v-model="dataInicio"
                  type="date"
                  label="Data Inicial"
                  placeholder="dd/mm/aaaa"
                  persistent-hint
                  outlined
                  dense
                  :rules="[rules.dataInicio]"
                  :error-messages="!validate ? 'Data Inicio deve ser menor que a Data Final' : null"
                  class="field-with-clear"
                >
                  <template v-slot:append-outer>
                    <v-btn
                      small
                      icon
                      class="clear-btn"
                      @click.stop="clearDate('dataInicio')"
                      :aria-label="'Limpar data inicial'"
                    >
                      <v-icon size="18">delete</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>

              <!-- Data Final -->
              <v-col xs="12" sm="6">
                <v-text-field
                  color="primary"
                  v-model="dataFim"
                  type="date"
                  label="Data Final"
                  placeholder="dd/mm/aaaa"
                  persistent-hint
                  outlined
                  dense
                  class="field-with-clear"
                >
                  <template v-slot:append-outer>
                    <v-btn
                      small
                      icon
                      class="clear-btn"
                      @click.stop="clearDate('dataFim')"
                      :aria-label="'Limpar data final'"
                    >
                      <v-icon size="18">delete</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-btn text color="primary" @click="closeDialog">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="saveDateRange">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import FunctionsCommuns from "@/util/FunctionsCommuns";

export default {
  name: "InputRangeDatePicker",
  props: {
    datesFormat: null
  },
  data: () => ({
    menu: false,
    dataInicio: null,
    dataFim: null,
    dataInicioFormated: null,
    menu1: false,
    menu2: false,
    validate: true,
    messageError: null,
    rules: {
      dataInicio: (value)=> !!value || 'Por favor preencha a data inicial'
    }
  }),
  computed: {
    isValidRange() {
      return this.dataInicio && ((this.dataFim
        && (this.dataInicio !== this.dataFim && this.dataInicio < this.dataFim) || !this.dataFim));
    },
    FunctionsCommuns() {
      return FunctionsCommuns;
    }
  },
  watch: {
    dataInicio(newValue) {
      if (!newValue) {
        this.$emit('startDate', null);
        return;
      }
      const d = dayjs(newValue);
      this.$emit('startDate', d.isValid() ? d.format('YYYY-MM-DD') : null);
    },
    dataFim(newValue) {
      if (!newValue) {
        this.$emit('endDate', null);
        return;
      }
      const d = dayjs(newValue);
      this.$emit('endDate', d.isValid() ? d.format('YYYY-MM-DD') : null);
    },
    datesFormat(newValue){
      if(!this.datesFormat){
        this.$refs.form.reset();
        this.dataInicio = null
        this.dataFim =  null
      }
    }
  },
  methods: {
    closeDialog() {
      this.menu = false;
      this.$refs.form.reset();
      this.$emit('startDate', null);
      this.$emit('endDate', null);
    },

    saveDateRange() {
      const isValid = this.$refs.form.validate();
      if(isValid){
        if (this.isValidRange) {
          const start = this.dataInicio ? (dayjs(this.dataInicio).isValid() ? dayjs(this.dataInicio).format('YYYY-MM-DD') : null) : null;
          const end = this.dataFim ? (dayjs(this.dataFim).isValid() ? dayjs(this.dataFim).format('YYYY-MM-DD') : null) : null;
          this.menu = false;
          this.$emit('startDate', start);
          this.$emit('endDate', end);
          this.validate = true
        }else{
          this.validate = false
        }
      }
    },

    clearDate(field) {
      if (field === 'dataInicio') {
        this.dataInicio = null;
      } else if (field === 'dataFim') {
        this.dataFim = null;
      }
    },
  }
};
</script>

<style scoped>
.field-with-clear >>> .v-input__append-outer {
  display: flex;
  align-items: center;
  margin-right: 2px;
}

.clear-btn {
  background-color: #546E7A !important;
  color: white !important;
  border-radius: 6px !important;
  height: 28px;
  width: 28px;
  min-width: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: none !important;
  padding: 0 !important;
}

.clear-btn .v-icon {
  line-height: 1;
  font-size: 16px;
}

.field-with-clear >>> .v-input--dense .clear-btn {
  height: 26px;
  width: 26px;
  min-width: 26px;
}

@media (max-width: 480px) {
  .clear-btn {
    height: 28px;
    width: 28px;
    min-width: 28px;
  }
}
</style>
